import UserArea from "./Upgrade";

export default UserArea;